import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

export default function SendOTP({ Transactioncomplete, setOTP }) {
    const formik = useFormik({
        initialValues: {
            otp: '',
        },
        validationSchema: Yup.object({
            otp: Yup.string()
                .length(6, 'OTP must be exactly 6 digits')  // OTP should be 6 digits
                .matches(/^[0-9]{6}$/, 'OTP must be a number')  // Only numbers allowed
                .required('OTP is required'),  // OTP is a required field
        }),
        onSubmit: (values) => {
            console.log('OTP Submitted:', values.otp);
            Transactioncomplete();  // Call the Transactioncomplete function when the form is submitted
        },
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="d-flex align-items-center send-otp ">
                    <div>
                        <input
                            id="otp"
                            name="otp"
                            type="text"
                            maxLength="6"
                            value={formik.values.otp}
                            onChange={(e) => {
                                formik.handleChange(e);
                                setOTP(e.target.value);
                            }}
                            onBlur={formik.handleBlur}
                            className='status mark-delivered'
                        />

                    </div>
                    <button className='status-btn buttons background-button' style={{ minWidth: 'max-content', maxWidth: '100%' }} type="submit">
                        Submit
                    </button>
                </div>
                {formik.touched.otp && formik.errors.otp ? (
                    <div className="error">{formik.errors.otp}</div>
                ) : null}
            </form>
        </>
    );
}
